export default __webpack_public_path__ + "static/photo-21-da4abb017ec725ecebdfb3775cbea505.jpg";